<template>
  <div class="overflow-x-hidden">
    <UCarousel
        v-slot="{ item, index }"
        loop
        arrows
        wheel-gestures
        :prev="{ variant: 'solid' }"
        :next="{ variant: 'solid' }"
        :items="items"
        :ui="{
                  item: 'size-full basis-full md:basis-1/4 lg:basis-1/6 ps-0 mx-4 rounded-lg overflow-hidden drop-shadow-md',
                  prev: 'sm:start-8',
                  next: 'sm:end-8',
                  container: 'ms-0',
                  viewport: 'overflow-visible'
                }"
    >
        <NuxtPicture
            :src="item"
            width="100%"
            height="100%"
            :alt="item"
            class="cursor-pointer"
            :img-attrs="{ class: 'size-full object-cover'}"
            @click="() => showImg(index)"
        />
    </UCarousel>
  </div>

    <VueEasyLightbox
        :visible="visibleRef"
        :imgs="imgs"
        :index="indexRef"
        @hide="onHide"
    />
</template>

<script setup lang="ts">
const route = useRoute();

const items = computed(() => {
    if (route.name === 'metall') {
        return [
            'metall/kita.jpg',
            'metall/mit_rampe.jpg',
            'metall/mit_rutsche.jpg',
            'metall/spielkombi.jpg',
            'metall/spielkombi_2.jpg',
            'metall/trigonbruecke.jpg',
            'metall/urban.jpg',
        ];
    }

    return [
        'BQ4C1535-1.jpg',
        'BQ4C2202-2.jpg',
        'BQ4C3431.jpg',
        'BQ4C1421-1.jpg',
        'BQ4C2038-1.jpg',
        'BQ4C0119-1.jpg',
        'BQ4C2940.jpg',
    ];
});

const imgs = computed(() => {
    if (route.name === 'metall') {
        return [
            '/_ipx/w_1280&f_jpeg/metall/kita.jpg',
            '/_ipx/w_1280&f_jpeg/metall/mit_rampe.jpg',
            '/_ipx/w_1280&f_jpeg/metall/mit_rutsche.jpg',
            '/_ipx/w_1280&f_jpeg/metall/spielkombi.jpg',
            '/_ipx/w_1280&f_jpeg/metall/spielkombi_2.jpg',
            '/_ipx/w_1280&f_jpeg/metall/trigonbruecke.jpg',
            '/_ipx/w_1280&f_jpeg/metall/urban.jpg',
        ];
    }

    return [
        '/_ipx/w_1280&f_jpeg/BQ4C1535-1.jpg',
        '/_ipx/w_1280&f_jpeg/BQ4C2202-2.jpg',
        '/_ipx/w_1280&f_jpeg/BQ4C3431.jpg',
        '/_ipx/w_1280&f_jpeg/BQ4C1421-1.jpg',
        '/_ipx/w_1280&f_jpeg/BQ4C2038-1.jpg',
        '/_ipx/w_1280&f_jpeg/BQ4C0119-1.jpg',
        '/_ipx/w_1280&f_jpeg/BQ4C2940.jpg',
    ];
});

const visibleRef = ref(false);
const indexRef = ref(0);

const showImg = (index) => {
    indexRef.value = index;
    visibleRef.value = true;
};
const onHide = () => (visibleRef.value = false);
</script>

<style scoped>

</style>
